import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyCorsi81Service
 * Client API per il catalogo normativo 81/08 e la mappatura
 * corsi LMS -> tipi 81 (gestione globale High Educational).
 */
export default class SafetyCorsi81Service {
    /** Catalogo normativo 81/08 (voci attive). */
    static getTipi = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/corsi81/tipi`;
            ApiService.postRequest(resolve, reject, url, {});
        });
    };

    /** Elenco corsi LMS con la mappatura 81 associata. */
    static getCorsi = (filtri) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/corsi81/corsi`;
            ApiService.postRequest(resolve, reject, url, { filtri: filtri || {} });
        });
    };

    /** Sostituisce la mappatura di un corso con l'insieme di id_tipi indicato. */
    static saveMapping = (id_corso, id_tipi) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/corsi81/saveMapping`;
            ApiService.postRequest(resolve, reject, url, { id_corso, id_tipi: id_tipi || [] });
        });
    };
}
